import { parseAssortmentId } from "helpers/product-collection";
import { View } from "constants/product-collection";
import isEqual from "lodash/isEqual";

const sanitizeQueryString = (queryString: any, pathname: string): any => {
    if (queryString.cartView === View.History) {
        delete queryString.cartView;
    }
    if (pathname.endsWith("/search") && queryString.filters) {
        delete queryString.filters;
    }
    return queryString;
};

export default function (nextState, replace, callback) {
    if (parseAssortmentId(nextState.params.id).isRollupMode) {
        const { pathname, query } = nextState.location;
        const querySanitized = sanitizeQueryString({ ...query }, pathname);

        const rollupPathname = `/assortment/${nextState.params.id}/shop`;
        if (!isEqual(query, querySanitized) || pathname !== rollupPathname) {
            replace({
                pathname: rollupPathname,
                query: querySanitized,
            });
        }
    }

    callback();
}
